import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=42a14823&scoped=true"
import script from "./SortItem.vue?vue&type=script&lang=js"
export * from "./SortItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a14823",
  null
  
)

export default component.exports